export default {
	annotation: {
		backToList: 'Volver a la lista',
		edit: 'Editar anotación',
		save: 'Guardar anotación',
		dragTip: 'Haga clic en el lienzo para agregar un punto de anotación, arrastre para ajustar la posición',
		noDeviceId: 'ID de dispositivo no encontrado',
		defaultDeviceName: 'Dispositivo desconocido',
		loadFailed: 'Error de carga',
		atLeastOnePoint: 'Por favor agregue al menos un punto de anotación',
		pointAdded: 'Punto de anotación agregado',
		pointDeleted: 'Punto de anotación eliminado',
		saveSuccess: 'Guardado exitosamente',
		saveFallback: 'Error de guardado, se guardó en caché local',
		annotationPoint: 'Punto de anotación',
		imageLoadFailed: 'Error de carga de imagen',
        editModeStarted: 'Modo de edición iniciado'
	}
}

